import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  clearLiveTrainingEvalDebug,
  subscribeLiveTrainingEvalDebug,
} from "../../utils/liveTrainingEvalDebugLog";
import "./LiveTrainingEvalDebugPanel.css";

function formatTime(ts) {
  try {
    return new Date(ts).toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  } catch {
    return "";
  }
}

function formatValue(value) {
  if (value == null) return "—";
  if (typeof value === "boolean") return value ? "yes" : "no";
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

export function LiveTrainingEvalDebugPanel({ snapshot = null, visible = true }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [log, setLog] = useState([]);

  useEffect(() => {
    if (!visible) return undefined;
    return subscribeLiveTrainingEvalDebug(setLog);
  }, [visible]);

  if (!visible) return null;

  const rows = snapshot
    ? Object.entries(snapshot).map(([key, value]) => ({ key, value }))
    : [];

  return (
    <section
      className={`lt-eval-debug${open ? " lt-eval-debug--open" : ""}`}
      aria-label={t("liveTrainingEvalDebugTitle", "Eval capture debug")}
    >
      <button
        type="button"
        className="lt-eval-debug__toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        {t("liveTrainingEvalDebugTitle", "Eval capture debug")}
        {snapshot?.status ? (
          <span className={`lt-eval-debug__pill lt-eval-debug__pill--${snapshot.status}`}>
            {snapshot.status}
          </span>
        ) : null}
      </button>
      {open ? (
        <div className="lt-eval-debug__body">
          {rows.length ? (
            <div className="lt-eval-debug__state">
              {rows.map(({ key, value }) => (
                <div key={key} className="lt-eval-debug__row">
                  <span className="lt-eval-debug__key">{key}</span>
                  <span className="lt-eval-debug__val">{formatValue(value)}</span>
                </div>
              ))}
            </div>
          ) : null}
          <div className="lt-eval-debug__log-head">
            <span>{t("liveTrainingEvalDebugLog", "Event log")}</span>
            <button
              type="button"
              className="lt-eval-debug__clear"
              onClick={clearLiveTrainingEvalDebug}
            >
              {t("clear", "Clear")}
            </button>
          </div>
          <ol className="lt-eval-debug__log" reversed>
            {log.length === 0 ? (
              <li className="lt-eval-debug__log-empty">
                {t("liveTrainingEvalDebugEmpty", "No events yet")}
              </li>
            ) : (
              log
                .slice()
                .reverse()
                .map((entry, i) => (
                  <li key={`${entry.ts}-${i}`}>
                    <time dateTime={new Date(entry.ts).toISOString()}>
                      {formatTime(entry.ts)}
                    </time>{" "}
                    <strong>{entry.label}</strong>
                    {entry.data !== undefined ? (
                      <code> {formatValue(entry.data)}</code>
                    ) : null}
                  </li>
                ))
            )}
          </ol>
        </div>
      ) : null}
    </section>
  );
}

export default LiveTrainingEvalDebugPanel;
